import React from 'react';
import Reflux from 'reflux';
import {withRouter} from 'react-router';
import {DmsTab} from "../../components";
import md5 from 'md5';
import moment from 'moment';

class BiReport extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['分析报表'],
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}')
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {opts, userData} = this.state;
        const account = userData.fatherAccount ? userData.fatherAccount : userData.loginName;
        const secret = md5(account + '-tengenDmc-' + moment().format('YYYY-MM-DD'));
        const url = 'https://newbi.tengen.com.cn/webroot/decision/link/Zr4W?客户编码=' + account + '&secret=' + secret;
        return <div>
            <DmsTab options={opts} defaultKey={0}>
            </DmsTab>
            <iframe width={'100%'} height={'800px'}
                    src={url}></iframe>
        </div>
    }
}

export default withRouter(BiReport);


// WEBPACK FOOTER //
// ./src/routes/report/biReport.js